{
  "editions": [
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-03",
      "variant": "en",
      "effectiveFrom": "2026-10-03",
      "sha256": "1937bffe4ea2c55846764c2231fec52fca6eb27f0435768ce657997043ad8a21",
      "file": "ai-data-consent/inapp-2026-10-03.en.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-03",
      "variant": "ru",
      "effectiveFrom": "2026-10-03",
      "sha256": "b9a28d101d5173e65e53d1c45e553672dc5a94536861dff1b969fac91306d4b3",
      "file": "ai-data-consent/inapp-2026-10-03.ru.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-12",
      "variant": "en",
      "effectiveFrom": "2026-10-12",
      "sha256": "472ceed2b9c477f34befbcc69c8b4a6984c7e67ed24f8418f6628c2a4fe760a2",
      "file": "ai-data-consent/inapp-2026-10-12.en.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-12",
      "variant": "en-intl",
      "effectiveFrom": "2026-10-12",
      "sha256": "1937bffe4ea2c55846764c2231fec52fca6eb27f0435768ce657997043ad8a21",
      "file": "ai-data-consent/inapp-2026-10-12.en-intl.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-12",
      "variant": "ru",
      "effectiveFrom": "2026-10-12",
      "sha256": "b6b320da507e05244a8fbd78aacb91002f7afad23f1eb7fbf65e6898aeac643e",
      "file": "ai-data-consent/inapp-2026-10-12.ru.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-12",
      "variant": "ru-intl",
      "effectiveFrom": "2026-10-12",
      "sha256": "b9a28d101d5173e65e53d1c45e553672dc5a94536861dff1b969fac91306d4b3",
      "file": "ai-data-consent/inapp-2026-10-12.ru-intl.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-23",
      "variant": "en",
      "effectiveFrom": "2026-10-23",
      "sha256": "572c2103fb0feaf0f6dbeb6e70ab4d2d53116c70f5782fbad843e9a87bb55480",
      "file": "ai-data-consent/inapp-2026-10-23.en.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-23",
      "variant": "en-intl",
      "effectiveFrom": "2026-10-23",
      "sha256": "12ea1d05075aa9aa7ad6c4278d8c28e3d62c45100264558e9a53fd7da1d6b9d3",
      "file": "ai-data-consent/inapp-2026-10-23.en-intl.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-23",
      "variant": "ru",
      "effectiveFrom": "2026-10-23",
      "sha256": "d9f405add9c219ed65faa90e1f252f15cbe9cefe50941c40835555b887232419",
      "file": "ai-data-consent/inapp-2026-10-23.ru.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-23",
      "variant": "ru-intl",
      "effectiveFrom": "2026-10-23",
      "sha256": "9c8702f856809c43dfd55de75fec975c3e7d025f52139b595296d5056bf8f50f",
      "file": "ai-data-consent/inapp-2026-10-23.ru-intl.txt"
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-30",
      "variant": "en",
      "effectiveFrom": "2026-10-30",
      "sha256": "e74ca55fd9b6f069f482321ccef638d7589130a39c7c835577cdb609a7016b03",
      "file": "ai-data-consent/inapp-2026-10-30.en.txt",
      "current": true
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-30",
      "variant": "en-intl",
      "effectiveFrom": "2026-10-30",
      "sha256": "12ea1d05075aa9aa7ad6c4278d8c28e3d62c45100264558e9a53fd7da1d6b9d3",
      "file": "ai-data-consent/inapp-2026-10-30.en-intl.txt",
      "current": true
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-30",
      "variant": "ru",
      "effectiveFrom": "2026-10-30",
      "sha256": "d6636244ee1c35aed786ab71ade55ea9d1f2094c19968dec399e99073b774dd7",
      "file": "ai-data-consent/inapp-2026-10-30.ru.txt",
      "current": true
    },
    {
      "documentId": "ai-data-consent",
      "version": "inapp-2026-10-30",
      "variant": "ru-intl",
      "effectiveFrom": "2026-10-30",
      "sha256": "9c8702f856809c43dfd55de75fec975c3e7d025f52139b595296d5056bf8f50f",
      "file": "ai-data-consent/inapp-2026-10-30.ru-intl.txt",
      "current": true
    },
    {
      "documentId": "ai-notice",
      "version": "2026-10-01",
      "variant": "ru",
      "effectiveFrom": "2026-10-01",
      "sha256": "68bd9d0b5323d196e7064946f503e00e1915ccfe70d09c6f0d67d494026398cd",
      "file": "ai-notice/2026-10-01.ru.txt"
    },
    {
      "documentId": "ai-notice",
      "version": "2026-10-30",
      "variant": "ru",
      "effectiveFrom": "2026-10-30",
      "sha256": "83e689a0e9dc0a8a12f40e0bd622e3d0ad7e000702e74e7af66ae9494ad169fb",
      "file": "ai-notice/2026-10-30.ru.txt",
      "current": true
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-11",
      "variant": "en",
      "effectiveFrom": "2026-10-11",
      "sha256": "cad4dac4c08a4b962d957977eec6751be7073418b2992c34471024d4bdbeb04e",
      "file": "cookie-notice/2026-10-11.en.txt"
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-11",
      "variant": "es",
      "effectiveFrom": "2026-10-11",
      "sha256": "aba36b17f23ca7cc70bd07f5d2d2a2c9c27f676f4c918724a716026992970e98",
      "file": "cookie-notice/2026-10-11.es.txt"
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-11",
      "variant": "ru",
      "effectiveFrom": "2026-10-11",
      "sha256": "95d6451476d64b72045b074686f453db9f796acda2e1fba17e3593196eac01c7",
      "file": "cookie-notice/2026-10-11.ru.txt"
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-19",
      "variant": "en",
      "effectiveFrom": "2026-10-19",
      "sha256": "52a36951e0c8d3b9a4a8da3d2402914731777467fdddcfa7492d64bf55a69a29",
      "file": "cookie-notice/2026-10-19.en.txt",
      "current": true
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-19",
      "variant": "es",
      "effectiveFrom": "2026-10-19",
      "sha256": "082e27b2f655098c543652137a43d5f7f187c577b1d86ab4bb579c6923e721cc",
      "file": "cookie-notice/2026-10-19.es.txt",
      "current": true
    },
    {
      "documentId": "cookie-notice",
      "version": "2026-10-19",
      "variant": "ru",
      "effectiveFrom": "2026-10-19",
      "sha256": "b41ad1ae40ecffe8d83a2d455a498210d674408b2486adfbbc00bdbb09136ce2",
      "file": "cookie-notice/2026-10-19.ru.txt",
      "current": true
    },
    {
      "documentId": "live-recording-notice",
      "version": "2026-10-11",
      "variant": "ru",
      "effectiveFrom": "2026-10-11",
      "sha256": "e1d27f8b3a2e9361255c8aac911864c74ddab8167fc9658819cf60d84412b066",
      "file": "live-recording-notice/2026-10-11.ru.txt",
      "current": true
    },
    {
      "documentId": "marketing-consent-full",
      "version": "2026-10-20",
      "variant": "ru",
      "effectiveFrom": "2026-10-20",
      "sha256": "46a7406da9ef1da7b4da0af1f41ab4c7d97afb75aac62faa4f6d00369089ee67",
      "file": "marketing-consent-full/2026-10-20.ru.txt",
      "current": true
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-05",
      "variant": "en",
      "effectiveFrom": "2026-10-05",
      "sha256": "f22da970f82e992e63a5907014e07bffb242f1518a0c067103197cc48bdaa27c",
      "file": "marketing-consent/2026-10-05.en.txt"
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-05",
      "variant": "es",
      "effectiveFrom": "2026-10-05",
      "sha256": "c5f1376baaa1c3739846c4a2ff059cc0860226c3b33ff3629cf86054808934c8",
      "file": "marketing-consent/2026-10-05.es.txt"
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-05",
      "variant": "ru",
      "effectiveFrom": "2026-10-05",
      "sha256": "58452cb9e2f1baac405a417c64e082a526424ebcaa0147c85ca9a30f9ee2c926",
      "file": "marketing-consent/2026-10-05.ru.txt"
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-30",
      "variant": "en",
      "effectiveFrom": "2026-10-30",
      "sha256": "c0d22ebec71a496231f762ed7360e60bb7c1762cb9ad44a34ef2991a28c0a612",
      "file": "marketing-consent/2026-10-30.en.txt",
      "current": true
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-30",
      "variant": "es",
      "effectiveFrom": "2026-10-30",
      "sha256": "90d1f294c7f9153d5b5cac042935be1080d63e6c73693ff3d1b18b05242a93b6",
      "file": "marketing-consent/2026-10-30.es.txt",
      "current": true
    },
    {
      "documentId": "marketing-consent",
      "version": "2026-10-30",
      "variant": "ru",
      "effectiveFrom": "2026-10-30",
      "sha256": "66bb87b9e13484e8fdb80bd948e2e0504b7b7517fcdc1090966074b913ae0ded",
      "file": "marketing-consent/2026-10-30.ru.txt",
      "current": true
    },
    {
      "documentId": "personal-data-consent",
      "version": "2026-10-22",
      "variant": "ru",
      "effectiveFrom": "2026-10-22",
      "sha256": "1dc367fe07f7807ef1407d8b1f4f6aa150c5913921890cb8fab7e18f047e97af",
      "file": "personal-data-consent/2026-10-22.ru.txt"
    },
    {
      "documentId": "personal-data-consent",
      "version": "2026-10-30",
      "variant": "ru",
      "effectiveFrom": "2026-10-30",
      "sha256": "76a8162684078037c08b70cba768c0c0fbd2fd27f731ea93b55827e8ddc838c9",
      "file": "personal-data-consent/2026-10-30.ru.txt",
      "current": true
    },
    {
      "documentId": "privacy-policy",
      "version": "2026-05-13",
      "variant": "en",
      "effectiveFrom": "2026-05-13",
      "sha256": "0db103ad72f51d8a17f0ef9de521e71c40ddf99248456d693c38ccb24612ada8",
      "file": "privacy-policy/2026-05-13.en.txt",
      "current": true
    },
    {
      "documentId": "privacy-policy",
      "version": "2026-05-13",
      "variant": "ru",
      "effectiveFrom": "2026-05-13",
      "sha256": "8ea99ac34c311f9a0ead9b9b43f636c5a17d96e45379fb4f3b9bbaa7b58ac8b2",
      "file": "privacy-policy/2026-05-13.ru.txt",
      "servedUntil": "2026-10-08",
      "source": "git 33a6c5f3a^ src/screens/LegalDocScreen.tsx"
    },
    {
      "documentId": "privacy-policy",
      "version": "2026-10-01",
      "variant": "ru",
      "effectiveFrom": "2026-10-01",
      "sha256": "f44a5b764692281aee998df7108e8fb51f5bad5ba9f1f031df600110ed9db0fa",
      "file": "privacy-policy/2026-10-01.ru.txt",
      "servedFrom": "2026-10-08"
    },
    {
      "documentId": "privacy-policy",
      "version": "2026-10-30",
      "variant": "ru",
      "effectiveFrom": "2026-10-30",
      "sha256": "d7ecf90e02859372f261eb7b60b5895a9b30720b4f392c2be4d0949d0816147a",
      "file": "privacy-policy/2026-10-30.ru.txt",
      "current": true
    },
    {
      "documentId": "terms-of-use",
      "version": "2026-08-07",
      "variant": "en",
      "effectiveFrom": "2026-08-07",
      "sha256": "4b68640a162c7c0e49747243b0c049961dd570218f63414c21375dfe6f6709b9",
      "file": "terms-of-use/2026-08-07.en.txt",
      "current": true
    },
    {
      "documentId": "terms-of-use",
      "version": "2026-08-07",
      "variant": "ru",
      "effectiveFrom": "2026-08-07",
      "sha256": "b0c823473ad74444955cb2138724620c03f08ce205b481a335a07998c7e5f51a",
      "file": "terms-of-use/2026-08-07.ru.txt",
      "servedUntil": "2026-10-02",
      "source": "git f0b5130c3^ src/screens/legal/termsOfUseRu.tsx"
    },
    {
      "documentId": "terms-of-use",
      "version": "2026-10-01",
      "variant": "ru",
      "effectiveFrom": "2026-10-01",
      "sha256": "0b1c83db1f8d9a09aba1ab01f81021639c9b60fbe4ea0c598a1147f9aa9d73b4",
      "file": "terms-of-use/2026-10-01.ru.txt",
      "servedFrom": "2026-10-02"
    },
    {
      "documentId": "terms-of-use",
      "version": "2026-11-04",
      "variant": "ru",
      "effectiveFrom": "2026-11-04",
      "sha256": "4858ff3985ed3c2913350f6d217fd4bb8fd0e05df0800afc8466348d45aeebcc",
      "file": "terms-of-use/2026-11-04.ru.txt",
      "current": true
    }
  ]
}
